import axios from 'axios'
import Cookie from 'js-cookie'
import { message } from 'antd'

const $axios = axios.create({
    timeout: 60 * 1000,
    baseURL: process.env.REACT_APP_UPLOAD_URL
})

// 请求拦截
$axios.interceptors.request.use((config) => {
    config.headers = {
        ...config.headers,
        token: process.env.REACT_APP_UPLOAD_TOKEN
    }
    const form = config.data
    const formData = new FormData();
    formData.append('path', form.path);
    formData.append('file', form.file);
    config.data = formData
    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截
$axios.interceptors.response.use(function (response) {
    const code = response.data.code
    if (code !== 200) {
        // 请求失败
        message.error(response.data.msg)
    }
    return Promise.resolve(response.data)
}, error => {
    return Promise.reject(error)
})

export default $axios
